export const CACHE_KEY = 'my-home';
